export const imageStyles = [
  'flat_illustration',
  'photo_realistic',
  'modern_vector',
  'corporate_3d',
] as const;
export type ImageStyle = (typeof imageStyles)[number];

export const imageScenes = [
  'abstract',
  'office_setting',
  'outdoor_setting',
  'remote/home',
] as const;
export type ImageScene = (typeof imageScenes)[number];

export const imageBrandColors = [
  'no',
  'low_emphasis',
  'medium_emphasis',
  'high_emphasis',
] as const;
export type ImageBrandColor = (typeof imageBrandColors)[number];

export interface GeneratedImage {
  mimeType: string;
  base64: string;
}

export type AspectRatio = [1, 1] | [9, 16] | [16, 9] | [3, 4] | [4, 3];
